







































/** 此页面是支付宝授信成功引导页，用于引导用户下载哈啰app */
import {
  defineComponent,
} from '@vue/composition-api';
import platform from '@/shared/utils/platform';
import { Button } from '@hb/coffee';
import { RouterV2Enum } from '@/router/router-names';
import { jumpToLocalPreRenderPage } from '@/shared/utils/jumpTo';
import { redirect } from '@/shared/utils/app-redirect';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import { commonDispatchPreRender } from '@/shared/utils/prerenderHelper';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import store from '@/store';

export default defineComponent({
  name: 'AlipayCreditGuide',
  components: {
    Button,
  },
  props: {
    amount: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { root }) {
    // 跳转到App下载
    const redirectApp = () => {
      ubtSetupPageButton('finance_loan_alipayCreditGuide_agree');
      redirect();
    };

    // 页面创建时的逻辑
    const initPage = () => {
      // 如果页面url上不包含beyondMP=true&userGuid=，且是支付宝小程序或钉钉小程序
      if (!window.location.href.includes('beyondMP=true&userGuid=') && (platform.isAlipayMini || platform.isDingTalk)) {
        root.$router.go(-1);

        const userGuid = store.state.base.originUserInfo.userGuid || '';
        // // 需要使用支付宝浏览器打开，才能绕过检测
        jumpToLocalPreRenderPage(RouterV2Enum.alipayCreditGuide, `beyondMP=true&userGuid=${userGuid}&amount=${props.amount}`, true);
      }
    };

    if (IS_PRERENDERING) {
      commonDispatchPreRender();
    } else {
      initPage();
    }

    return {
      redirectApp,
    };
  },
});
